export default __webpack_public_path__ + "static/media/Walker's Arm-straps of the Ancestors.dcf0211c.jpg";